import { render, staticRenderFns } from "./GroupNew.vue?vue&type=template&id=f81a61fa&scoped=true&"
import script from "./GroupNew.vue?vue&type=script&lang=js&"
export * from "./GroupNew.vue?vue&type=script&lang=js&"
import style0 from "./GroupNew.vue?vue&type=style&index=0&id=f81a61fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81a61fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
